import React from "react"
import { Link, graphql } from "gatsby"
// import product from "../../../images/product.jpg"
import { GatsbyImage } from "gatsby-plugin-image"
import { title, price } from "./card.module.css"
const Card = ({ product }) => {
  const slug = `/${product.subcategory?.category?.slug?.current}/${product?.subcategory?.slug?.current}/${product?.slug?.current}`

  function dynamicPrice() {
    const dof = product.discountOrFlashSale
    if (dof === "flashSale") {
      return product.flashPrice
    } else if (dof === "campaign") {
      return product.campPrice
    } else {
      return product.discountPrice
    }
  }

  // console.log(dynamicPrice())
  // const getPrice = discountedprice
  //   ? discountedprice
  //   : product.discountPrice
  //   ? product.discountPrice
  //   : product.price
  const discount = parseInt(
    ((product.price - dynamicPrice()) / product.price) * 100
  )
  return (
    <div
      className="relative flex flex-col m-2  justify-stretch  group hover:border-primary  
      transform transition-all duration-500 hover:shadow-xl
      border-black border-2 rounded-lg "
    >
      <Link to={slug} className="flex flex-col w-full h-full p-2  ">
        {discount < 100 && (
          <div className="absolute top-0 right-0 bg-black text-white font-bold z-10 px-3 duration-500 rounded-bl-md rounded-tr-md group-hover:bg-primary group-hover:text-white">
            -{discount}%
          </div>
        )}
        <div className="relative flex flex-col items-center">
          {product?.image && (
            <GatsbyImage
              image={product?.image[0]?.asset?.gatsbyImageData}
              alt={product.title}
              objectFit="contain"
              className="object-center object-contain max-h-32 sm:max-h-40  2xl:max-h-60 2xl:min-h-40"
            />
          )}
          <h2 className={title}>{product.title}</h2>
          <h3 className={price}>
            {" "}
            {dynamicPrice() ? (
              <>
                <span className="line-through px-2">{product.price}TK</span>
                <span> {dynamicPrice()} Tk</span>
              </>
            ) : (
              <span className="px-2">{product.price}TK</span>
            )}{" "}
            <span></span>
          </h3>
        </div>
      </Link>
    </div>
  )
}

export default Card

export const query = graphql`
  fragment ProductCard on SanityProduct {
    title
    _id
    discountPrice
    flashPrice
    discountOrFlashSale
    campPrice
    hide
    subcategory {
      slug {
        current
      }
      category {
        title
        slug {
          current
        }
      }
    }
    slug {
      current
    }
    price
    image {
      asset {
        gatsbyImageData(placeholder: BLURRED)
      }
    }
  }
`
